import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { DepartmentService } from '../../services/department.service';
import { EmployeeService } from '../../services/employee.service';

@Component({
    selector: 'app-create-department',
    templateUrl: './create-department.component.html',
    styleUrls: ['./create-department.component.css', '../../app.component.css']
})

export class CreateDepartmentComponent implements OnInit, OnDestroy {

    departmentForm: FormGroup;
    department: any;

    responsibles = {};
    responsibleInit: any;
    responsibleText = '';

    applyInPrompterReportVal = false;
    applyInSupervisorReportVal = false;
    applyInCheckClockVal = false;
    applySecurityReportVal = false;

    geSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private departmentService: DepartmentService,
                private employeeService: EmployeeService) {
        this.loadResponsibles();
    }

    ngOnInit() {
        this.departmentForm = this.formBuilder.group({
            name: ['', Validators.required],
            comments: '',
            responsible: '',
            applyInPrompterReport: '',
            applyInSupervisorReport: '',
            applyInCheckClock: '',
            applySecurityReport: '',
        });
    }

    onSubmitDepartment() {
        this.department = this.saveDepartment();

        this.departmentService.postDepartment(this.department).then(res => {
            this.departmentForm.reset();
            this.router.navigate(['/departments']);
        });
    }

    saveDepartment() {
        const currentDate = new Date();

        let responsibleId = '';
        if (this.departmentForm.get('responsible').value) {
            responsibleId = this.responsibles[this.departmentForm.get('responsible').value];
        }

        const departmentJson = {
            active: true,
            applyInCheckClock: this.departmentForm.get('applyInCheckClock').value,
            applyInPrompterReport: this.departmentForm.get('applyInPrompterReport').value,
            applyInSupervisorReport: this.departmentForm.get('applyInSupervisorReport').value,
            applySecurityReport: this.departmentForm.get('applySecurityReport').value,
            comments: this.departmentForm.get('comments').value,
            createdAt: currentDate,
            name: this.departmentForm.get('name').value,
            responsibleId: responsibleId,
            updatedAt: currentDate
        };

        return departmentJson;
    }

    loadResponsibles() {
        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployees => {
            const dataEmployee = {};

            for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                dataEmployee[employeeDisplayValue] = null;
                this.responsibles[employeeDisplayValue] = tempEmployees[idx].id$;
            }

            this.responsibleInit = {
                'data': dataEmployee,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.carriers[val]);
                }
            };
        });
    }

    onBlurResponsible() {
        if (this.responsibles[this.responsibleText] === undefined) {
            this.responsibleText = '';
        }
    }

    ngOnDestroy() {
        this.geSubs.unsubscribe();
    }

}
